import { NgModule } from '@angular/core';
import { PedidosComponent } from './pedidos/pedidos';
import { IonicModule } from 'ionic-angular';
import { LocationSelectorComponent } from './location-selector/location-selector';
@NgModule({
	declarations: [PedidosComponent, LocationSelectorComponent],
	imports: [IonicModule],
	exports: [PedidosComponent, LocationSelectorComponent]
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts